/// <amd-module name="Widgets/AnalyticsSprintBurndown/AnalyticsSprintBurndownWidgetComponents/TotalWorkProjectionHelper" />
import { DataSeries } from "VSS/Features/Charts/Contracts";
import { getWorkItemStackedEffortColumnSeries, reduceEffortToSeriesData } from "Widgets/Burndown/BurndownWidgetComponents/BurndownChartOptionFactory";
import { WorkItemEffort } from "Widgets/Burndown/BurndownWidgetComponents/BurndownDataContract";

/** Contains policy for computing peak scope using a pre-normalized data set describing remaining work of each day. */
export function determinePeakScope(dailyRemainingWork: (number | null)[]): number {
    let totalAddedWork = 0;

    // Track for peak work - Start with work present on day 1 and accumulate work additions after day 1.
    // The policy of this algorithm is ported from Tfs/Service/WorkItemTracking/WebAccess/Charts/Component/ChartDataComponent.cs
    // described as "adjustedInitial"
    for (let i = 0; i < dailyRemainingWork.length; i++) {
        const toNumber = (value: number | null) => {
            return value != null ? value : 0;
        };

        const current = toNumber(dailyRemainingWork[i]);
        const previous = i > 0 ? toNumber(dailyRemainingWork[i - 1]) : 0;
        totalAddedWork += Math.max(current - previous, 0);
    }
    return totalAddedWork;
}
/** Contains policy for normalizing datasets and evaluating peak scope used to produce idealized trend line. */
export function getPeakScope(
    effort: WorkItemEffort[],
    sampleDates: string[],
    todayInAccountTimezone: string,
    stackByWorkItemType: boolean,
    witColorDictionary?: { [key: string]: string } | undefined
): number {
    // let dailyRemainingWork2 = [10, 6, 7, 4, 1];
    const dailyRemainingWork = stackByWorkItemType
        ? collapseStackedWork(getWorkItemStackedEffortColumnSeries(effort, sampleDates, todayInAccountTimezone, witColorDictionary))
        : reduceEffortToSeriesData(effort, sampleDates, todayInAccountTimezone);
    return determinePeakScope(dailyRemainingWork);
}

/** Consolidates datasets from separate series into a single per-day totals array. */
function collapseStackedWork(series: DataSeries[]): number[] {
    const remainingWork = [];
    if (series.length > 0) {
        const duration = series[0].data.length;
        const seriesCount = series.length;
        for (let i = 0; i < duration; i++) {
            let pendingRemainingWork = 0;
            for (let j = 0; j < seriesCount; j++) {
                const workSample = series[j].data[i] as (number | null);
                pendingRemainingWork += workSample != null ? workSample : 0;
            }
            remainingWork[i] = pendingRemainingWork;
        }
    }
    return remainingWork;
}
